import { render, staticRenderFns } from "./CaracteristicasFisicas.vue?vue&type=template&id=0f735e24&scoped=true&lang=pug&"
import script from "./CaracteristicasFisicas.vue?vue&type=script&lang=js&"
export * from "./CaracteristicasFisicas.vue?vue&type=script&lang=js&"
import style0 from "./CaracteristicasFisicas.vue?vue&type=style&index=0&id=0f735e24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f735e24",
  null
  
)

export default component.exports